import { getAnalyticsConsent } from "./src/lib/analytics-consent";
import { initPostHogIfAccepted } from "./src/lib/posthog-browser";

initPostHogIfAccepted(getAnalyticsConsent());
